const counterClockWise = {
    data() {
        return {
            jejuPoints : [
                {y:33.522007557690934 , x: 126.522007557690934 },
                {y:33.53826451315533 , x: 126.59775818299603},
                {y:53826451315533, x: 126.6304780770003},
                {y:33.55730099345093 , x: 126.64315678196417 },
                {y:33.553499790966015 , x: 126.67728608672265},
                {y:33.566238166859065 , x: 126.76012316282275 },
                {y:33.559574711002725  , x: 126.83061396423113 },
                {y:33.53076824894765 , x: 126.86718655058 },
                {y:33.525899046494615 , x: 126.90594745270292 },
                {y:33.50397963594821 , x: 126.91647501483914},
                {y:33.47974273670002 , x: 126.91391608733498 },
                {y:33.474708389098424 , x: 126.93853655966005 },
                {y:33.46244760278596, x: 126.94078267096236 },
                {y:33.39267933335718, x: 126.90884277912367},
                {y: 33.3202047255205, x: 126.85083912213261},
                {y:33.27446165767325 , x: 126.75268055385335},
                {y:33.25228264267469 , x: 126.6483506527566 },
                {y:33.23019448307666 , x: 126.59556955323562 },
                {y:33.222818608123596 , x: 126.47476956452051},
                {y:33.22927575725048 , x: 126.3188726294825},
                {y:33.18862087271376, x: 126.27252057177542 },
                {y:33.238163688135096 , x: 126.21168433097043 },
                {y:33.29374300494857 , x: 126.15209487662914 },
                {y:33.34052518744513, x: 126.1585163687612 },
                {y:33.43839136468062, x: 126.2587430095846 },
                {y:33.47331613717014 , x: 126.31146129002107},
                {y:33.49004263360563 , x: 126.39293390073814},
                {y:33.48777235830719 , x: 126.40069687181057},
                {y:33.5129490908293 , x: 126.48163370795052},
                {y:33.51960183863864 , x: 126.48572736844405},
            ],

            udoPoints: [
                {y: 33.50572352652031, x: 126.9383424472079},
                {y: 33.52693535513275, x: 126.95227881768106},
                {y: 33.503283847689254, x: 126.97433249312701},
                {y: 33.48640266681463, x: 126.96211414955707}
            ],
            
            udoCenter : {y: 33.50508184498104, x: 126.95584236663366},

            isCross: false
        }
    },

    methods: {
        ccw(p1, p2, p3) {
            let cross_product = (p2.x - p1.x) * (p3.y - p1.y) - (p2.y - p1.y) * (p3.x - p1.x);

            if (cross_product > 0) {
                return 1; // 교차하지 않음
            } else if (cross_product < 0) {
                return -1; // 두 선분(경계선 / 중심-차량위치)가 교차함
            } else {
                return 0; // 두 선분(경계선 / 중심-차량위치)이 같은 선상에 있음
            }
        },

        getCrossPoint(center, cPoint) {
            this.isCross = false;
            let j = 0, k = 0;
            let isJejuCross = false;
            let isUdoCross = false;
            
            if(center == null) center = { x: 126.539392, y: 33.396194 } // 지도 중심좌표

            for(let i=0; i<this.jejuPoints.length; i++) {
                if(i == this.jejuPoints.length - 1) {
                    j = 0;
                } else {
                    j = i + 1;
                }

                if(this.ccw(center, cPoint, this.jejuPoints[i]) * this.ccw(center, cPoint, this.jejuPoints[j]) < 0 
                    && this.ccw(this.jejuPoints[i], this.jejuPoints[j], center) * this.ccw(this.jejuPoints[i], this.jejuPoints[j], cPoint) < 0) {
                        isJejuCross = true;
                }

                if(isJejuCross) break;
            }

            for(let i=0; i<this.udoPoints.length; i++) {
                if(i == this.udoPoints.length - 1) {
                    k = 0;
                } else {
                    k = i + 1;
                }

                if(this.ccw(this.udoCenter, cPoint, this.udoPoints[i]) * this.ccw(this.udoCenter, cPoint, this.udoPoints[k]) < 0 
                    && this.ccw(this.udoPoints[i], this.udoPoints[k], this.udoCenter) * this.ccw(this.udoPoints[i], this.udoPoints[k], cPoint) < 0) {
                        isUdoCross = true;
                }

                if(isUdoCross) break;
            }

            if(isJejuCross && isUdoCross) this.isCross = true;
            
            // console.log('isJejuCross : ' + isJejuCross + ', isUdoCross : ' + isUdoCross + ', isCross : ' +  this.isCross) ;
            return this.isCross;
        }
    } 
}

export default counterClockWise